import { useLocation, useNavigate } from 'react-router'
import AppRahmen from '../komponenten/AppRahmen'

/**
 * Auffangseite für unbekannte Adressen. Vorher landete man hier stillschweigend auf dem
 * Startbildschirm, was so aussah, als sei die aufgerufene Seite kaputt.
 */
export default function NichtGefunden() {
  const ort = useLocation()
  const navigiere = useNavigate()

  return (
    <AppRahmen
      titel="Seite nicht gefunden"
      unter={ort.pathname}
      fuss={
        <button className="btn btn-primaer" onClick={() => navigiere('/')}>
          Zum Start
        </button>
      }
    >
      <p className="sek">
        Diese Adresse gibt es nicht. Ansichten wie die Büroprüfung, das Ergebnis oder der Verifizierungsreport
        gehören immer zu einer bestimmten Erfassung und werden von deren Übersicht aus geöffnet.
      </p>
    </AppRahmen>
  )
}
